function circOut(t) {
  return Math.sqrt(1 - ( --t * t ))
}

module.exports = circOut


//////////////////
// WEBPACK FOOTER
// ./node_modules/eases/circ-out.js
// module id = 33
// module chunks = 0 1